<section class="empty-watchlist">
  <div class="mdc-layout-grid empty-watchlist__layout">
    <div class="mdc-layout-grid__inner empty-watchlist__grid">
      <div
        class="mdc-layout-grid__cell mdc-layout-grid__cell--span-6-desktop mdc-layout-grid__cell--span-12-tablet mdc-layout-grid__cell--span-12-mobile empty-watchlist__images">
        <img
          class="empty-watchlist__image"
          src="assets/watchlist/empty-watchlist.svg"
          alt="Leere Merkliste"
          i18n-alt="@@featureWatchlist-emptyWatchlist-image" />
      </div>
      <div
        class="mdc-layout-grid__cell mdc-layout-grid__cell--span-6-desktop mdc-layout-grid__cell--span-12-tablet mdc-layout-grid__cell--span-12-mobile empty-watchlist__texts">
        <h2 class="empty-watchlist__header" i18n="@@featureWatchlist-emptyWatchlist-title">
          Aktuell ist Ihre Merkliste leer,<br />aber das lässt sich leicht ändern.
        </h2>
        @if (fairId && displayDescription) { @if ( (fairsConfig?.fairs)![fairId] &&
        !(fairsConfig?.fairs)![fairId].discoveryHidden) {
        <p class="empty-watchlist__description" i18n="@@featureWatchlist-emptyWatchlist-description">
          <a [routerLink]="['/fairs', fairId, 'search']">Entdecken</a> Sie Inhalte und merken Sie sich
          <a [routerLink]="['/fairs', fairId, 'exhibitors', 'letters']" [queryParams]="{ character: 'A' }"
            >Unternehmen</a
          >
          und mehr. Diese können Sie hier später einfach wiederfinden.
        </p>
        } @else {
        <p class="empty-watchlist__description" i18n="@@featureWatchlist-emptyWatchlist-altDescription">
          Entdecken Sie Inhalte und merken Sie sich
          <a [routerLink]="['/fairs', fairId, 'exhibitors', 'letters']" [queryParams]="{ character: 'A' }"
            >Unternehmen</a
          >
          und mehr. Diese können Sie hier später einfach wiederfinden.
        </p>
        }
        <ng-template #discoveryHidden>
          <p class="empty-watchlist__description" i18n="@@featureWatchlist-emptyWatchlist-altDescription">
            Entdecken Sie Inhalte und merken Sie sich
            <a [routerLink]="['/fairs', fairId, 'exhibitors', 'letters']" [queryParams]="{ character: 'A' }"
              >Unternehmen</a
            >
            und mehr. Diese können Sie hier später einfach wiederfinden.
          </p>
        </ng-template>
        }
      </div>
    </div>
  </div>
</section>
